<template>
  <div id="coach_cert_ready_outer" v-if="coachItem != null">
    <div v-if="stepIndex < 4" style="display: flex;flex-direction: column;flex-wrap: nowrap;align-items: center;">
      <el-steps id="informations_add_steps" :active="stepIndex" :align-center="true">
        <el-step v-for="(item, index) in stepList"
        :key="'sub_step_' + index"
        :icon="item.icon"
        :title="item.title"
        />
      </el-steps>
      <div style="width: 100%;max-width: 900px;margin-top: 45px;" >
        <div style="text-align:center; color: #fc1a34;margin-bottom: 15px;" v-if="errorMsg != null">
          <span>{{errorMsg}}</span>
        </div>
        <base-infors-view v-if="stepIndex == 0"
          :coach="coachItem.coach"
          v-on:next="gotoNextStep" />

        <certs-infors-view v-else-if="stepIndex == 1"
          :coachItem="coachItem"
          v-on:back="backToPreviousStep"
          v-on:next="gotoNextStep" />

        <coachings-infors-view v-else-if="stepIndex == 2"
          :coachItem="coachItem"
          v-on:back="backToPreviousStep"
          v-on:next="gotoNextStep" />

        <trainings-infors-view v-else-if="stepIndex == 3"
          :coachItem="coachItem"
          v-on:back="backToPreviousStep"
          v-on:next="gotoNextStep" />
      </div>
    </div>
    <confirm-infors-view v-else :item="coachItem" v-on:backToEidtPage="backToFirstStep" />

  </div>
</template>

<script>
  import AddBaseInformation from "./children/AddBaseInformation.vue";
  import AddCertsInformation from "./children/AddCertsInformation.vue";
  import AddCoachingsInformation from "./children/AddCoachingsInformation.vue";
  import AddTrainingsInformation from "./children/AddTrainingsInformation.vue";
  import ConfirmInformation from "./children/ConfirmInformation.vue";
  export default {
    name: 'CoachCertReadyVue',
    props: {
      coachItem: {
        type: Object,
        default: null,
      }
    },
    components: {
      BaseInforsView: AddBaseInformation,
      CertsInforsView: AddCertsInformation,
      CoachingsInforsView: AddCoachingsInformation,
      TrainingsInforsView: AddTrainingsInformation,
      ConfirmInforsView: ConfirmInformation
    },
    data () {
      return {
        stepList: [
          {
            title: '基本信息',
            icon: 'el-icon-s-custom',
          },
          {
            title: '资格信息',
            icon: 'el-icon-collection',
          },
          {
            title: '执教履历',
            icon: 'el-icon-basketball',
          },
          {
            title: '参培经历',
            icon: 'el-icon-timer',
          },
        ],
        stepIndex: 0,
        errorMsg: null,
      }
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      httpManager() {
        return this.$store.state.http;
      },
    },
    watch: {
      coachItem: {
        handler (val, oldVal) {
          // console.log('更新 coach item');
          // console.log(val);
          this.dealWithUpdateCoachData();
        },
        deep: true,
      }
    },
    mounted() {
      // console.log('coachCertReady --- 11');
      this.dealWithUpdateCoachData();
      this.configErrorRemark();
    },
    methods: {
      configErrorRemark() {
        let idErrorRemark = this.$store.state.idErrorRemark;
        if (idErrorRemark != null) {
          this.errorMsg = idErrorRemark;
          this.$store.commit('setIdErrorRemark', null);
        } else {
          let coachItem = this.coachItem;
          if (coachItem != null && coachItem.coach.status == 8 && coachItem.coach.auditRemark != null && coachItem.coach.auditRemark != '') {
            this.errorMsg = coachItem.coach.auditRemark;
          }
        }
      },

      dealWithUpdateCoachData() {
        let coachItem = this.coachItem;
        if (coachItem == null || coachItem.coach == null) {
          return;
        }

        let coach = coachItem.coach;
        let status = coach.status;
        let auditStatus = coach.auditStatus;
        if (auditStatus == 0) {
          this.stepIndex = 0;
        } else {
          if (status == 0) {
            this.stepIndex = 0;
          }
          else if (status == 1) {
            this.stepIndex = 1;
          }
          else if (status == 2) {
            this.stepIndex = 2;
          }
          else if (status == 3) {
            this.stepIndex = 3;
          }
          else if (status == 4) {
            this.stepIndex = 4;
          }
        }
        // this.stepIndex = 1;
      },
      backToFirstStep() {
        this.stepIndex = 0;
      },
      backToPreviousStep() {
        this.stepIndex -= 1;
      },
      gotoNextStep() {
        this.stepIndex += 1;
      }
    }
  }
</script>

<style scoped>
  #coach_cert_ready_outer {
    padding-left: 15px;
    padding-right: 15px;
  }

  #informations_add_steps {
    max-width: 1000px;
    width: 100%;
    margin-top: 15px;
  }

  #informations_add_steps /deep/ .el-step .el-step__title {
    font-size: 14px;
    line-height: 16px;
  }

  #informations_add_steps /deep/ .el-step__head.is-finish  {
    border-color: #C0C4CC;
  }

  #informations_add_steps /deep/ .el-step__title.is-process, #informations_add_steps /deep/ .el-step__head.is-process {
    color: #FC1A34;
  }

  #informations_add_steps /deep/ .el-step__title.is-finish, #informations_add_steps /deep/ .el-step__head.is-finish {
    color: #000;
  }

</style>



// WEBPACK FOOTER //
// src/components/personal/coachApplications/CoachCertReady.vue